import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';

const QK = ['team-members'];
const ADMIN_QK = ['team-members-admin'];

function invalidateAll(qc: ReturnType<typeof useQueryClient>): void {
  qc.invalidateQueries({ queryKey: QK });
  qc.invalidateQueries({ queryKey: ADMIN_QK });
  qc.invalidateQueries({ queryKey: ['approacher'] });
}

export function useSetVacation() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (v: { id: string; from: string; to: string }) =>
      pb.send(`/api/team-members/vacation/${v.id}`, {
        method: 'POST',
        body: { from: v.from, to: v.to },
      }),
    onSuccess: () => {
      invalidateAll(qc);
      toast('Vacaciones marcadas', 'success');
    },
    onError: (err: Error) =>
      toast(err.message || 'Error al marcar vacaciones', 'error'),
  });
}

export function useClearVacation() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (id: string) =>
      pb.send(`/api/team-members/vacation/${id}`, { method: 'DELETE' }),
    onSuccess: () => {
      invalidateAll(qc);
      toast('Vacaciones canceladas', 'success');
    },
    onError: (err: Error) =>
      toast(err.message || 'Error al cancelar vacaciones', 'error'),
  });
}
